import useFacilityData from '@usas/ui-web/state/facility/UseFacilityData';
import usePreCompLocationData from '../../../state/preCompLocation/UsePreCompLocationData';

const usePreCompLocationFacilitiesPoolsDetail = () => {
  const { facilityState } = useFacilityData();
  const { preCompLocationState } = usePreCompLocationData();

  return {
    preCompLocationState,
    facilityState
  };
};

export default usePreCompLocationFacilitiesPoolsDetail;